import { IShift } from "../../../MillSettingsStepInterfaces";
import { IShiftsAssignmentWithDetailsFormat } from "./ShiftDeletionFormInterfaces";

export const shiftChangesFormatter = (
    changedShifts: IShift[],
    newShiftsAssignments: IShiftsAssignmentWithDetailsFormat[],
    effectiveDate: Date,
): IShift[] => {
    const changedShiftsFormatted = changedShifts.map((changedShift) => {
        const productionLinesNewShiftAssignment = newShiftsAssignments.filter((plShiftIds) =>
            plShiftIds.shiftsIdsDetails.some((shiftDetails) => {
                if (changedShift.shift_id) {
                    return changedShift.shift_id === shiftDetails.id;
                } else {
                    return shiftDetails.id < 1 && shiftDetails.name === changedShift.name;
                }
            }),
        );
        if (productionLinesNewShiftAssignment.length) {
            return {
                ...changedShift,
                production_line_shifts_changes: [
                    ...changedShift.production_line_shifts_changes,
                    ...productionLinesNewShiftAssignment.map((plAssignment) => ({
                        production_line_id: plAssignment.production_line_id,
                        name: plAssignment.name,
                        effective_at: effectiveDate,
                    })),
                ],
            };
        } else {
            return changedShift;
        }
    });

    return changedShiftsFormatted;
};
